import { useQuery } from "react-query"
import { fetchLoadHistory } from "./api"

// eslint-disable-next-line import/prefer-default-export
export const useLoadHistory = params => {
  return useQuery(["fetchLoadHistory", params], fetchLoadHistory)
}
